import React from 'react'

interface Props {
  faster: number
  digits?: number
}

interface State { }

export class FasterValue extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
  }

  formatFaster(ms: number) {
    const digits = this.props.digits || 2
    return this.props.faster.toFixed(digits)
  }

  public render() {
    return (
      <>
        <span className="faster-value">x {this.formatFaster(this.props.faster)} 高速化</span>
      </>
    )
  }
}